export class Evaluacion {
  evaluacion_id: number;
  grupo_id: number;
  codigo: string;
  descripcion: string;
  ponderacion: number;
  cantidad: number;
  constructor(evaluacion_id: number = 0,
              grupo_id: number,
              codigo: string,
              descripcion: string,
              ponderacion: number,
              cantidad: number) {
    this.evaluacion_id = evaluacion_id;
    this.grupo_id = grupo_id;
    this.codigo = codigo;
    this.descripcion = descripcion;
    this.ponderacion = ponderacion;
    this.cantidad = cantidad;
  }
}
